module.exports = __webpack_public_path__ + "img/jar.be5030ca.webp";